<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        title="社員からの評判"
      />
      <div class="grid-x align-justify">
        <div class="medium-12 cell">
          <p class="margin-0">
            「社員からの評判」として公開する内容を設定します。
          </p>
          <p class="boss-text">
            「社員からの評判」は企業様管理画面でのみ登録・編集が可能です。営業担当者・制作担当者側では編集できません。
            <a
              class="float-right"
              data-test="format-download-link"
              target="_blank"
              href="/help/hyouban_format.xlsx"
            >
              <img
                src="@/assets/images/icon-download-green.svg"
                class="pega-template-btn"
                alt
              >
              ご回答シートのダウンロード
            </a>
          </p>
          <br>
        </div>
        <div class="float-left boss-check-container">
          全
          <span
            class="boss-check-number"
            data-test="displayed-count"
          >{{ displayedCount }}</span>件中
          公開中の評判
          <span
            class="boss-check-number"
            data-test="published-count"
          >{{ publishedCount }}</span> 件（最大100件までご登録可能）
          <a
            v-if="isDisplay"
            :href="honneURL"
            data-test="honne-link"
            target="_blank"
          >
            ▶︎ 実際に公開中の画面はこちら
          </a>
          <!-- 初期描画時、公開判定終了までは文言を表示させない為、null判定している -->
          <span
            v-else
            class="boss-notice-text"
            data-test="hidden-display-honne"
          >{{ isDisplay === null ? '' : '公開中の評判がありません。ご登録・公開設定をお願いいたします。' }}</span>
        </div>
        <div class="medium-3 cell">
          <button
            class="float-right boss-button boss-button-new"
            data-test="register"
            @click="onRegisterClick"
          >
            <span class="boss-icon-new" />
            <span class="boss-button-new-text">新規作成する</span>
          </button>
        </div>
      </div>
      <div
        id="real-intententions"
        data-test="real-intention-wrap"
        class="boss-table-wrap"
      >
        <real-intentions
          ref="RealIntentions"
          :real-intentions="realIntentions"
          @update-display="judgeIsDisplay"
          @fetch="fetch"
        />
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import RealIntentions from '@/components/organisms/RealIntentions'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Indicator from '@/lib/indicator'
const USER_URL = process.env.USER_ENDPOINT

export default {
  name: 'RealIntentionTop',
  components: {
    SettingHeader,
    RealIntentions
  },
  data () {
    return {
      realIntentions: [],
      isDisplay: null
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ]),
    displayedCount () {
      return (this.isLoading || this.isDisplay === null) ? '...' : this.realIntentions.length
    },
    publishedCount () {
      return (this.isLoading || this.isDisplay === null) ? '...' : _.filter(this.realIntentions, realintention => realintention.isPublished).length
    },
    honneURL () {
      return USER_URL + `/honne/${this.currentUser.companyId}/`
    },
    isLoading: () => Indicator.getLoadingStatus()
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      Indicator.emitShow()
      this.fetchRealIntentions()
    },
    fetchRealIntentions () {
      this.$http.secured.get('/real_intention/real_intentions').then((response) => {
        this.$set(this, 'realIntentions', response.data)
        this.judgeIsDisplay()
        if (this.realIntentions.length > 100) {
          this.$toasted.global.error({ message: '登録数が100件を超えています。不要な評判を削除してからご登録ください。' })
        }
      }).finally(() => {
        Indicator.emitHide()
      })
    },
    fetchIsDisplay () {
      this.$http.secured.get('/real_intention/is_display')
        .then((response) => {
          this.setIsDisplayProperty(response.data)
        })
    },
    judgeIsDisplay () {
      if (_.some(this.realIntentions, v => v.isPublished)) {
        this.fetchIsDisplay()
      } else {
        this.setIsDisplayProperty(false)
      }
    },
    setIsDisplayProperty (isDisplay) {
      this.$set(this, 'isDisplay', isDisplay)
    },
    onRegisterClick () {
      this.$http.secured.get('/real_intention/real_intentions').then((response) => {
        this.$set(this, 'realIntentions', response.data)
        this.judgeIsDisplay()
        if (this.realIntentions.length >= 100) {
          this.$toasted.global.error({ message: '登録数が100件を超えています。不要な評判を削除してからご登録ください。' })
        } else {
          this.$router.push({ name: 'realIntentionRegister' })
        }
      })
    }
  }
}
</script>
